import { isSavedAnalysis } from '@modules/analysis/helpers';
import { UUID } from 'v2/core/entities/uuid';

export const isAnalysisAuthor = ({
  analysisID,
  isEditable,
}: {
  analysisID: UUID;
  isEditable: boolean;
}) => {
  return isSavedAnalysis(analysisID) && isEditable;
};
